const WineSearcherResult = (props: {
  result: any
}) => {
  return (
    <a
      target="_blank"
      rel="noreferrer noopener"
      href={ props.result["link"] }
      className="block transition bg-white shadow-md hover:shadow-lg p-4 rounded cursor-pointer flex"
    >
      <div className="w-full">
        <h4>{ props.result["seller_name"] }</h4>
        <p className="text-sm font-light">{ props.result["state"] && props.result["state"] + ","} { props.result["country_raw"] }</p>
      </div>
      <div className="w-1/2 text-right">
        <p className="text-red">${ props.result["price"] }</p>
        <p className="text-sm font-light">{ props.result["bottle_size"] }</p>
      </div>
    </a>
  )
}

export default WineSearcherResult;
